<template>
  <div class="row" id="table-hover-animation">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Tariflar</h4>
          <button
            class="btn btn-primary waves-effect waves-light"
            @click="addTariff"
          >
            Yangi tarig qo'shish
          </button>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-hover mb-0">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col" style="width: 30%">
                      <h5><b>Nomlanishi</b></h5>
                    </th>
                    <th scope="col" style="width: 30%">
                      <h5><b>Qurilmalar soni</b></h5>
                    </th>
                    <th scope="col">
                      <h5><b>Narxi</b></h5>
                    </th>
                    <th scope="col" />
                  </tr>
                </thead>
                <transition name="fade" :duration="2000">
                  <tbody class="table-bordered" v-if="loaded">
                    <tr v-for="(tariff, index) in tariffs">
                      <td scope="row">{{ index + 1 }}</td>
                      <td>{{ tariff.tariffName }}</td>
                      <td>{{ tariff.deviceCount }}</td>
                      <td>{{ tariff.summa }}</td>
                      <td>
                        <button
                          class="btn btn-icon rounded-circle btn-flat-info"
                          title="Tahrirlash"
                          @click="editTariff(tariff)"
                        >
                          <i
                            style="font-size: 1.5rem"
                            class="feather icon-edit"
                          />
                        </button>
                        <button
                          class="btn btn-icon rounded-circle btn-flat-danger"
                          title="O'chirish"
                          @click="deleteTariff(tariff.id)"
                        >
                          <i
                            style="font-size: 1.5rem"
                            class="feather icon-trash-2"
                          />
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </transition>
              </table>
            </div>
          </div>

          <div class="d-flex justify-content-center">
            <v-pagination
              v-model="currentPage"
              :classes="bootstrapPaginationClasses"
              :page-count="totalSize"
            />
          </div>
        </div>
      </div>
    </div>
    <Modal
      :modal="showModal"
      @modal-closed="showModal = false"
      :modal-size="modalSize"
    >
      <tariff-form
        v-if="showModal && deleteApi === ''"
        :tariff="tariff"
        @saved="getTariffs(currentPage - 1)"
      />
      <deleting-modal
        v-if="showModal && deleteApi !== ''"
        :delete-api="deleteApi"
        @deleted="getTariffs(currentPage - 1)"
      />
    </Modal>
  </div>
</template>

<script>
import TariffForm from "./TariffForm";
import vPagination from "vue-plain-pagination";
import Modal from "../../components/Modal";
import DeletingModal from "../../components/DeletingModal";

export default {
  name: "TarifList",
  components: { DeletingModal, Modal, TariffForm, vPagination },
  data() {
    return {
      tariffs: [],
      tariff: {},
      showModal: false,
      loaded: false,
      deleteApi: "",
      modalSize: "",
      totalSize: 1,
      currentPage: 1,
      bootstrapPaginationClasses: {
        ul: "pagination",
        li: "page-item",
        liActive: "active",
        liDisable: "disabled",
        button: "page-link",
      },
    };
  },
  methods: {
    getTariffs(skip = 0) {
      this.loaded = false;
      this.$api
        .get(`admin/Tariff/TariffGetAll?skip=${skip}&take=10`)
        .then((res) => {
          if (!res.error) {
            this.tariffs = res.result.data;
            this.totalSize = Math.ceil(res.result.total / 10);
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.loaded = true;
        });
    },
    addTariff() {
      this.modalSize = "modal-lg";
      this.deleteApi = "";
      this.tariff = this.createTariffObject();
      this.showModal = true;
    },
    editTariff(tariff) {
      this.modalSize = "modal-lg";
      this.deleteApi = "";
      this.tariff = tariff;
      this.showModal = true;
    },
    deleteTariff(tariffId) {
      this.modalSize = "modal-sm";
      this.deleteApi = `admin/Tariff/TariffDelet/${tariffId}`;
      this.showModal = true;
    },
    createTariffObject() {
      return {
        id: 0,
        tariffName: "",
        summa: null,
        deviceCount: null,
        comment: "",
      };
    },
  },
  watch: {
    currentPage() {
      this.getTariffs(this.currentPage - 1);
    },
  },
  created() {
    this.getTariffs();
  },
};
</script>
